// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @media print {
  body * {
    visibility: hidden;
    font-family: "Times New Roman", Times, serif;
  }
  .hideBtnn {
    display: none;
  }
  #hideDatee {
    display: none;
  }
  #divToPrintt,
  #divToPrintt * {
    visibility: visible;
  }
  #divToPrintt {
    position: absolute;
    left: 0;
    top: 0;
    zoom: 150%;
    font-size: 20px;
    page-break-inside: avoid;
  }
  /* .causeListHeadingg {
      page-break-after: always;
    } */
/* #tabledivv table td {
    height: 100px;
    table-layout: fixed;
  }
  #tabledivv table tr {
    page-break-inside: avoid;
    page-break-after: always;
  }
} */

@media print {
  body * {
    visibility: hidden;
    font-family: "Times New Roman", Times, serif;
  }
  .hideBtnn {
    display: none;
  }
  #hideDatee {
    display: none;
  }
  #divToPrintt,
  #divToPrintt * {
    visibility: visible;
  }
  #divToPrintt {
    position: absolute;
    left: 0;
    top: 0;
    zoom: 150%;
    font-size: 20px;
    page-break-inside: avoid;
  }
  /* .causeListHeadingg {
      page-break-after: always;
    } */
  #tabledivv table td {
    height: 100px;
    table-layout: fixed;
    /* increase bottom padding */
    padding-bottom: 250px !important;
  }
  #tabledivv table tr {
    page-break-inside: avoid;
    page-break-after: always;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/causeList/printCauseListByPage.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;OAyBO;AACP;;;;;;;;GAQG;;AAEH;EACE;IACE,kBAAkB;IAClB,4CAA4C;EAC9C;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,eAAe;IACf,wBAAwB;EAC1B;EACA;;OAEK;EACL;IACE,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;EAClC;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;AACF","sourcesContent":["/* @media print {\n  body * {\n    visibility: hidden;\n    font-family: \"Times New Roman\", Times, serif;\n  }\n  .hideBtnn {\n    display: none;\n  }\n  #hideDatee {\n    display: none;\n  }\n  #divToPrintt,\n  #divToPrintt * {\n    visibility: visible;\n  }\n  #divToPrintt {\n    position: absolute;\n    left: 0;\n    top: 0;\n    zoom: 150%;\n    font-size: 20px;\n    page-break-inside: avoid;\n  }\n  /* .causeListHeadingg {\n      page-break-after: always;\n    } */\n/* #tabledivv table td {\n    height: 100px;\n    table-layout: fixed;\n  }\n  #tabledivv table tr {\n    page-break-inside: avoid;\n    page-break-after: always;\n  }\n} */\n\n@media print {\n  body * {\n    visibility: hidden;\n    font-family: \"Times New Roman\", Times, serif;\n  }\n  .hideBtnn {\n    display: none;\n  }\n  #hideDatee {\n    display: none;\n  }\n  #divToPrintt,\n  #divToPrintt * {\n    visibility: visible;\n  }\n  #divToPrintt {\n    position: absolute;\n    left: 0;\n    top: 0;\n    zoom: 150%;\n    font-size: 20px;\n    page-break-inside: avoid;\n  }\n  /* .causeListHeadingg {\n      page-break-after: always;\n    } */\n  #tabledivv table td {\n    height: 100px;\n    table-layout: fixed;\n    /* increase bottom padding */\n    padding-bottom: 250px !important;\n  }\n  #tabledivv table tr {\n    page-break-inside: avoid;\n    page-break-after: always;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
